import styled from 'styled-components';

export const BreadcrumbContainer = styled.div`
  width: 100%;
  margin-bottom: 16px;

  .ant-breadcrumb {
    font-size: 14px;

    a {
      display: inline-flex;
      align-items: center;
      color: rgba(0, 0, 0, 0.45);
      transition: color 0.2s;

      &:hover {
        color: var(--primary);
      }

      svg {
        font-size: 14px;
      }
    }

    .ant-breadcrumb-separator {
      color: rgba(0, 0, 0, 0.25);
    }

    > span:last-child {
      color: rgba(0, 0, 0, 0.85);
      font-weight: 500;
    }
  }
`;
